
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/no-question-is-a-stupid-question",
      function () {
        return require("private-next-pages/articles/no-question-is-a-stupid-question.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/no-question-is-a-stupid-question"])
      });
    }
  